module.exports = __webpack_public_path__ + "static/character--keoni-shaka@3x.353e4dc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/character--keoni-shaka@3x.png
// module id = 59
// module chunks = 77152941127580 105603797122985 114276838955818 126609682503911 164055321636205 252234152318474